<template>
<div class="tags-box">
    <div class="hg-tag-list" v-if="!editing_tag">
        <div class="header">
            <h4>
                <span v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'CLIPS':'TAG'"></span> 
                <small v-if="event.tags && event.tags.length">({{event.tags && event.tags.length}})</small>
            </h4>
            <!-- event.tags && event.tags.length &&  -->
            <button     @click="addTag()" 
                        class="btn-red btn-add-tag" 
                        :title="$options.filters.i18n($hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'ADD_CLIP':'ADD_TAG')" 
                        v-if="canAdd">
                <font-awesome-icon :icon="['fas','plus']"/>&nbsp;
                <!-- <img :src="getTagIcon(0)" /> -->
            </button>
            <a href="javascript: void 0"  @click="$emit('close')" class="close" v-if="!clipCreatingMode">
                <font-awesome-icon :icon="['fas','times']"/>
            </a>
        </div>
        <div class="tag-list" v-if="event.tags && event.tags.length">
            <div    class="tag-wrapper" 
                    @click="selectTag()" 
                    :class="{'selected': !selected_tag }" 
                    v-if="(event.has_video !== false) && $hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG">
                <div class="tag">
                    <div class="tag-icon">
                        <img src="../../assets/images/film-maker.svg" />
                    </div>
                    <div class="tag-body">
                        <span class="tag-header">
                            <span class="tag-type" v-i18n="'ENTIRE_RECORDING'" />
                        </span>
                    </div>
                </div>
            </div>
            <div class="tag-wrapper" v-for="tag in event.tags" 
                            :key="tag.id" 
                            @click="selectTag(tag)" 
                            :class="{
                                'current': !$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG && tag.start_time<=currentTime && tag.end_time>=currentTime,
                                'selected': selected_tag && tag.id == selected_tag.id, 
                                'in-edit': selected_tag && clipCreatingMode && tag.id == selected_tag.id,
                                'has-markers': selected_tag  && tag.id == selected_tag.id && selected_tag.markers
                            }">
                <div class="tag">
                    <div class="tag-icon">
                        <img :src="getTagIcon(tag.id_tag_type)" />
                    </div>
                    <div class="tag-body">
                        <span class="tag-header">
                            <span class="tag-type">
                                {{getTagTypeName(tag.id_tag_type)}}
                            </span>
                            <small class="tag-time">
                                {{tag.start_time | sec2time(true)}} - {{tag.end_time | sec2time(true)}}
                            </small>
                        </span>
                        <small class="tag-visibility" v-i18n="'VISIBILITY_' + Object.keys($hisport.visibility_types).find(x=> $hisport.visibility_types[x] == tag.visibility)" />
                        <small class="tag-description">{{tag.description}}</small>
                        <!--MARKERS-->
                        <ul class="tag-markers" v-if="selected_tag && clipCreatingMode && tag.id == selected_tag.id">
                            <li class="tag-marker" 
                                :class="{
                                    'first': $index == 0,
                                    'last': $index == selected_tag.markers.length - 1,
                                    'selected': Math.abs(marker.ts - currentTime)<=markerThresholds
                                }"
                                v-for="(marker, $index) in selected_tag.markers" 
                                :key="marker.id"  
                                :marker-id="marker.id" 
                                :title="JSON.stringify(marker)"
                                @click.prevent.stop="onMarkerClick(marker)">
                                <div class="marker-body">
                                    <span>{{marker.ts | sec2time(true)}} - {{'(' + marker.x.toFixed(1) + ',' + marker.y.toFixed(1) + ')'}}</span>
                                </div>
                                <div class="marker-actions">
                                    <button class="btn-transparent marker-action" href="javascript:void 0" @click.prevent.stop="onMarkerRemove(marker)" v-if="!marker.locked">
                                        <font-awesome-icon :icon="['fas','trash']" size="lg"/>
                                    </button>
                                    <!-- <button class="btn-transparent marker-action" href="javascript:void 0" @click.prevent.stop="gotoMarkerById(marker.id)">
                                        <font-awesome-icon :icon="['fas','pencil-alt']" size="lg"/>
                                    </button> -->
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="tag-actions" v-if="!clipCreatingMode">
                        <button @click.prevent.stop="onTagRemove(tag)" :tag-id="tag.id" class="btn-transparent">
                            <font-awesome-icon :icon="['fas','trash']" size="lg"/>
                        </button>
                        <button @click.prevent.stop="editTag(tag)" class="btn-transparent">
                            <font-awesome-icon :icon="['fas','pencil-alt']" size="lg"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="tag-list" v-else>
            <p v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'NO_CLIPS':'NO_TAGS'" style="margin-top:20px;color:rgba(255,255,255,.6)"/>
            <button  @click="addTag()" class="btn-red" v-if="canAdd">
                <!-- <img :src="getTagIcon(0)" />&nbsp; -->
                <font-awesome-icon :icon="['fas','plus']"/>&nbsp;
                <span v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'ADD_CLIP':'ADD_TAG'" />
            </button>
        </div>
    </div>
    <div class="tag-form-wrapper" v-if="editing_tag">
        <tag-form   :event="event"
                    :mentionable-users="mentionableUsers"   
                    :tag-types="tagTypes" 
                    :tag="editing_tag" 
                    :on-cancel="exitEditing"
                    :on-tag-update="onTagUpdate" 
                    :on-tag-add="onTagAdd"></tag-form>
    </div>
</div>
</template>
<style>
.btn-add-tag{
    left:0;
    top:0;
    width:40px;
    height:40px;
    position:absolute;
}
.tags-box{
    overflow-x: hidden;
    overflow-y: auto;
    height:100%;
    padding:5px 10px;
}

.tags-box .header{
    display:flex;
    flex-direction: row;
    xpadding:20px 5px 10px 5px;
    height:40px;
}
.tags-box .header h4{
    margin:0;
    flex: 1 1 auto;
    padding:0;
    height:40px;
    line-height:35px;
}

.tags-box .header .close{
    color: var(--white);
    flex: 0 0 auto;
    line-height:30px;
}
</style>
<script>
const DEFAULT_CLIP_TIME_SECONDS = 20;
// import timepicker from "../_components/timepicker"
import TagForm from "../_components/tag_form";
export default {
    components:{
        // timepicker
        TagForm
    },
    props: {
        mentionableUsers: {
            type: Array,
            default: function(){ return []; }
        },
        enableTagClip: {
            type: Boolean,
            default: false
        },
        markerThresholds: {
            type: Number,
            default: 1
        },
        currentTime: {
            type: Number,
            default: 0
        },
        duration: {
            type: Number,
            default: 0
        },
        event: {
            type: Object,
            default: function(){
                return {tags:[]}
            }
        },
        clipCreatingMode: {
            type: Boolean,
            default: false
        },
        onTagAdd: {
            type: Function
        },
        onTagUpdate: {
            type: Function
        },
        onTagRemove: {
            type: Function
        },
        onTagSelect: {
            type: Function
        },
        onTagEdit: {
            type: Function
        },
        onMarkerClick:{
            type: Function
        },
        onMarkerRemove: {
            type: Function
        },
        tagTypes: {
            type: Array,
            default: function(){ return [] }
        }
    },
    data(){
        return {
            editing_tag:    null,
            selected_tag:   null
        }
    },
    methods: {
        selectTag: function(tag){
            this.onTagEdit();
            this.selected_tag = tag;
            this.onTagSelect(tag);
        },
        time2sec: function(str){
            var toks = str.split(":");
            return toks[0] * 60 * 60 + toks[1] * 60 + toks[2];
        },
        getTagIcon: function(id){
            var tt = this.tagTypes.find(function(x){ return x.id == id; })
            if(tt)
                return tt.icon;
            else
                return '/tag-icons/tag-manual.svg'
        },
        getTagTypeName: function(id){
            var tt = this.tagTypes.find(function(x){ return x.id == id; })
            if(tt && tt.name)
                return tt.name[this.$hisport.current_culture];
            else
                return "AUTO"
        },
        addTag: function(skipEdit){
            this.selected_tag = null;
            var deltaStart = this.currentTime - DEFAULT_CLIP_TIME_SECONDS;
            var startTime = Math.max(deltaStart, 0);
            var endTime = Math.min(this.currentTime + ((deltaStart<0)?(deltaStart * -1):0), this.duration);
            var tag = {
                id_tag_type:        this.tagTypes[0].id,
                start_time:         startTime, 
                end_time:           endTime,
                id_event:           this.event && this.event.id,
                id_creator:         this.$hisport.getUserId(),
                visibility:         this.$hisport.visibility_types.PRIVATE,
                visibility_custom:  null,
                description:        "",
                mentions:           [],
                markers:            []
            }
            if(!skipEdit){
                console.log("EDITING TAG", tag)
                this.editing_tag = tag;
                this.onTagEdit(this.editing_tag);
            }
            return tag;
        },
        exitEditing: function(){
            this.editing_tag = null;
            this.onTagEdit();
        },
        editTag: function(tag){
            this.selectTag();
            this.editing_tag = tag;
            this.onTagEdit(tag);
        }
    },
    computed: {
        canAdd(){
            return  !this.$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG && 
                    this.enableTagClip &&       // 1.clip abilitate
                    !this.clipCreatingMode &&   // 2.non siamo in modalità creazione clip (markers)
                    !!this.$hisport.me()        // 3.l'utente è loggato 
        }
    }
}
</script>